import axios from 'axios';
import qs from 'qs';
//员工session c96fd70c663398f8261ff09b2fa8727a
//正式
export const host = '//'+window.location.host+'/';//'//eton.gzairnest.com/';//
const supplyUrl = host+'supply.php';
const userUrl = host+'user.php';
const goodUrl = host+'goods.php';
const serviceUrl = host+'service.php'
// 测试

export const session_id = localStorage.getItem('shouhou_session_id');



//校验
function validate (res) {
    if (!res.data.error || Number(res.data.error) === 0) {
        return res;
    } else if (Number(res.data.error) === 9002 || Number(res.data.error) === 9003) {
        //重新登录
        
    } else {
        throw Error(res.data.msg);
    }
}
//商品展示
export async function getProducts (params) {
    return axios(supplyUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            ...params,
        }
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//购物车商品
export async function getCartProducts () {
    return axios(supplyUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            step: 'get_cart_goods_list',
        }
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//添加或修改 购物车商品
export async function addCartProducts (goods, rec_id) {
    let params = {
        session_id: localStorage.getItem('shouhou_session_id'),
        step: 'add_supply_cart',
    };
    if (rec_id !== undefined) {
        params.rec_id = rec_id;
    }
    return axios.post(supplyUrl, 'goods=' + JSON.stringify(goods), {
        params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            // 'Content-Type': 'multipart/form-data; charset=utf-8'
        }
    }).then(res => {
        console.log(res)
        return validate(res);
    });
}

//订单列表里添加商品
export async function addorderList(goods_attr_id,goods_number,goods_price,order_id,goods_ids){
    let params = {
    }
    return axios.post(userUrl, params, {
        params:
            {
                act:'edit_order',
                step:'add_goods',
                session_id,
                goods_attr_id:goods_attr_id,
                goods_number:goods_number,
                goods_price:goods_price,
                order_id:order_id,
                goods_id:goods_ids
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            'Content-Type': 'multipart/form-data; charset=utf-8'
        }

    }).then(res => {
        console.log(res)
        return validate(res);
    });
}

//修改购物车商品数量
export async function setCartProducts (rec_id, goods_number) {
    return axios.post(supplyUrl, qs.stringify({rec_id, goods_number}), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            step: 'update_supply_cart_num',
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            // 'Content-Type': 'multipart/form-data; charset=utf-8'
        }
    }).then(res => {
        return validate(res);
    });
}
//修改商品提成
export async function setGoodsRate (goods_id, lowest_rate,lowest_price,beyond_rate) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'update_staff_goods_rate',
            goods_id:goods_id,
            lowest_rate:lowest_rate,
            lowest_price: lowest_price,
            beyond_rate: beyond_rate
        },
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        //     // 'Content-Type': 'multipart/form-data; charset=utf-8'
        // }
    }).then(res => {
        return validate(res);
    });
}
//收货地址
export async function getAddress () {
    return axios(supplyUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            step: 'get_consignee_list',
        }
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//地址级联
export async function getAddressSelect (region_id) {
    return axios(userUrl, {
        params: {
            act: 'get_yuyue_region',
            region_id
        }
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//新建地址故不用传address_id，编辑的话传递这个值
export async function changeAddress (params) {
    return axios.post(supplyUrl, qs.stringify(params), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            step: 'update_consignee',
        },
    }).then(res => {
        return validate(res);
    });
}

//删除地址
export async function delAddress (id) {
    return axios(supplyUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            step: 'drop_consignee',
            id
        },
    }).then(res => {
        return validate(res);
    });
}

//价格查询
export async function getPrice ({id, attr}) {
    return axios(goodUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'price',
            number: 1,
            id,
            attr,
        },
    }).then(res => {
        // console.log(res.data)
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//可选参数查询
export async function getAttrList (goods_id) {
    return axios(supplyUrl, {
        params: {
            step: 'specification',
            goods_id,
        },
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//提交订单
export async function order (params) {
    return axios.post(supplyUrl, qs.stringify(params), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            step: 'post_done',
        },
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//订单列表
export async function orderList (params) {
    return axios(userUrl, {
        params: {
            act: 'order_list',
            ...params
        },
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//获取支付方式
export async function getPayMent (order_sn) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'get_orders_payment',
            order_sn,
        },
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}

//修改支付方式
export async function changePayMent (order_sn, pay_id) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'set_orders_payment',
            order_sn,
            pay_id,
        },
    }).then(res => {
        return validate(res);
    });
}

//取消订单
export async function cancelOrder (order_sn) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'cancel_order',
            order_sn,
        },
    }).then(res => {
        return validate(res);
    });
}

//移除订单
export async function deleteOrders (order_sn) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'delete_order',
            order_sn: order_sn,
        },
    }).then(res => {
        return validate(res);
    });
}

//删除订单
export async function deleteOrder (order,rec_id) {
    if (order.length!=1) {
        return axios(userUrl, {
            params: {
                session_id: localStorage.getItem('shouhou_session_id'),
                act: 'edit_order',
                step: 'del_goods',
                order_id: order[0].order_id,
                rec_id: rec_id
            },
        }).then(res => {
            return validate(res);
        });
        return false;
    }
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'order_del',
            order_id:order[0].order_id,
        },
    }).then(res => {
        console.log(res)
        return validate(res);
    });
}

//获取预约安装
export async function getAppointment (order_sn) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'get_orders_yuyue',
            order_sn,
        },
    }).then(res => {
        return validate(res);
    });
}

//提交预约数据
export async function postAppointment (params) {
    return axios.post(userUrl, qs.stringify(params), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'post_orders_yuyue',
        },
    }).then(res => {
        return validate(res);
    });
}
export async function ChangeOrderMsg (params) { //修改订单信息
    return axios.post(userUrl, qs.stringify(params), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'update_order_address',
        },
    }).then(res => {
        return validate(res);
    });
}

//获取单个订单信息
export async function getOrderDetail (order_sn) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'order_detail',
            order_sn,
        },
    }).then(res => {
        return validate(res);
    });
}

//佣金详情
export async function getBrokerageDetail (params) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'commission_details',
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}

//收费标准
export async function getChargeStandard () {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'get_charges',
        },
    }).then(res => {
        return validate(res);
    });
}

//获取个人信息
export async function getUserInfo () {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'profile',
        },
    }).then(res => {

        return validate(res);
    });
}

//修改个人信息
export async function postUserInfo (params) {
    return axios.post(userUrl, qs.stringify(params), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'act_edit_profile',
        },
    }).then(res => {
        return validate(res);
    });
}

//订单报表
export async function getReportInfo (params) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'get_Order_Report_Series',
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}


// 添加 修改 员工
export async function handleSubmit (params,name,phone,qunx){
    return axios(userUrl,{
         params: {
             session_id: localStorage.getItem('shouhou_session_id'),
            name,
            phone,
            qunx,
            ...params
        },
    }).then(res=>{
         return validate(res);
    })
}

//修改订单商品
export async function changeorder(hbln,goods_id,qtyRaw,price,rec_id,product_id,order_id,arrt){
    let params = {
        session_id: localStorage.getItem('shouhou_session_id'),
        act: 'edit_order',
        step:'edit_goods',
        goods_attr:hbln,
        goods_id: goods_id,
        goods_number:qtyRaw,
        goods_price:price,
        rec_id:rec_id,
        goods_attr_id:arrt,
        product_id:product_id,
        order_id:order_id
    }
    return axios.post(userUrl, qs.stringify(params)).then(res => {
         return validate(res);
    })
}

//登录
export async function Login (username, password) {
    return axios(serviceUrl, {
        params: {
            act: 'login',
            username: username,
            password: password
        },
    }).then(res => {
        return validate(res);
    });
}
//已完成支付订单列表
export async function orderSuccess (params) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'order_done_list',
            ...params
        },
    }).then(res => {
        return validate(res);
    }).catch((err) => {
        console.log(err);
    });
}
//获取安装单列表
export async function getInstallList (params) {
    return axios(serviceUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'install_list',
            gettype: 'yx',
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}
//获取安装公司列表
export async function getInstallCompany (page) {
    return axios(serviceUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'company_list',
            page: page,
        },
    }).then(res => {
        return validate(res);
    });
}
//下派安装公司
export async function ChargeCompany (install_id, company_id, company_name) {
    return axios(serviceUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'change_company',
            install_id: install_id,
            company_id: company_id,
            company_name: company_name
        },
    }).then(res => {
        return validate(res);
    });
}
//获取结算单列表
export async function getFinishList (params) {
    return axios(serviceUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'install_jiesuan',
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}

//询价单列表
export async function InquiryList (params) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'inquiry_list',
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}
//编辑询价单
export async function EditInquiry (params) {
    return axios.post(userUrl, qs.stringify(params), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'inquiry_update',
        },
    }).then(res => {
        return validate(res);
    });
}
//询价单改到项目列表
export async function InquiryToPro (params) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'inquiry_status',
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}
//项目列表
export async function ProjectList (params) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'inquiry_list',
            status: 1,
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}
//项目回退询价单
export async function ProjectToInq (params) {
    return axios(userUrl, {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'inquiry_return',
            ...params
        },
    }).then(res => {
        return validate(res);
    });
}
//项目下单
export async function OrderInquiry (params) {
    return axios.post(userUrl, qs.stringify(params), {
        params: {
            session_id: localStorage.getItem('shouhou_session_id'),
            act: 'inquiry_order_done',
        },
    }).then(res => {
        return validate(res);
    });
}



// WEBPACK FOOTER //
// ./src/stores/api.js